import React from "react"
import { useTranslation } from "react-i18next"
import { ITooltipProps } from "../Tooltip"

const TooltipExactSearchContent = ({ filterAll }: { filterAll?: boolean }) => {
    const { t } = useTranslation()

    return (
        <ul>
            {!!filterAll && <li>{t('searchTooltip.filterAll')}</li>}
            <li>{t('searchTooltip.line1')}</li>
            <li>{t('searchTooltip.line2')}</li>
            <li>{t('searchTooltip.line3')}</li>
            <li>{t('searchTooltip.line4')}</li>
        </ul>
    )
}

export const tooltipExactSearch: Omit<ITooltipProps, "children"> = {
    content: <TooltipExactSearchContent />,
    maxWidth: "630px",
}

export const tooltipExactSearchFilterAll: Omit<ITooltipProps, "children"> = {
    content: <TooltipExactSearchContent filterAll />,
    maxWidth: "630px",
}
